import React, { useEffect, useState } from 'react';
import { compose, withHandlers, withState, lifecycle } from 'recompose';
import { connect } from 'react-redux';

import withQueryParams from 'HOC/withQueryParams';
import Category from './Category';
import ApiService from 'services/api';
import logger from 'services/logger';
import ArticleCategoriesModule from 'modules/articleCategories';

const Categories = props => {
  const { categories, queryParams } = props;
  const [currentCategory, setCategory] = useState(queryParams.category);

  return (
    <ul className="left-menu">
      <Category
        category={{ id: 'all', name: 'All' }}
        currentCategory={currentCategory}
        onChange={setCategory} />
      {categories.map(category => (
        <Category
          key={category.id}
          category={category}
          currentCategory={currentCategory}
          onChange={setCategory} />
      ))}
    </ul>
  );
};

export default compose(
  withQueryParams,
  connect(
    state => {
      return {
        categories: state.articleCategories.list
      };
    },
    {
      getCategories: ArticleCategoriesModule.getList
    }
  ),
  lifecycle({
    componentDidMount() {
      this.props.getCategories();
    }
  })
)(Categories);
